import dynamic from 'next/dynamic';
import { UpcomingResBannerProps } from './UpcomingResBanner.types';

export const UpcomingResBanner = dynamic<UpcomingResBannerProps>(
  () => import('./UpcomingResBanner').then(module => module.UpcomingResBanner),
  { ssr: false }
);
